/* ============================================================================
   Next10 — Brinde por faixa de valor (cards colecionáveis)
   ----------------------------------------------------------------------------
   Replica a regra da Loja Integrada. As faixas NÃO ficam aqui: vêm dos settings
   do tema, injetados em window.n10Brinde por layout/theme.liquid. Marketing muda
   num lugar só e a barra de progresso do carrinho lê os mesmos valores.

   ATENÇÃO — o preço do brinde é R$ 0,01 de propósito. Existe um desconto
   automático de 100% ("Brinde Card Next10") que zera o item no carrinho e no
   checkout. Manter valor unitário preserva a forma fiscal que desce para o
   Bling e para a NF-e. NÃO zerar o preço do produto.

   O subtotal considerado nunca inclui o próprio brinde.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__n10Brinde) return;
  window.__n10Brinde = true;

  var CFG = window.n10Brinde || {};
  var VARIANT_ID = Number(CFG.variantId || 0);

  /* Faixas em centavos, da maior para a menor. */
  var FAIXAS = [
    { minimo: Number(CFG.faixa3 || 0), cards: 3 },
    { minimo: Number(CFG.faixa2 || 0), cards: 2 },
    { minimo: Number(CFG.faixa1 || 0), cards: 1 },
  ].filter(function (f) {
    return f.minimo > 0;
  });

  if (!VARIANT_ID || !FAIXAS.length) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');
  var rodando = false;
  var repetir = false;

  /* -------------------------------------------------------------- utilidades */

  function json(url, opcoes) {
    return fetch(BASE + url, opcoes).then(function (r) {
      return r.json();
    });
  }

  function ehBrinde(item) {
    return item.variant_id === VARIANT_ID || item.id === VARIANT_ID;
  }

  /* Soma o carrinho ignorando as linhas de brinde. */
  function baseDeCalculo(carrinho) {
    var total = 0;
    for (var i = 0; i < carrinho.items.length; i++) {
      var item = carrinho.items[i];
      if (!ehBrinde(item)) total += item.final_line_price;
    }
    return total;
  }

  function cardsDevidos(base) {
    for (var i = 0; i < FAIXAS.length; i++) {
      if (base >= FAIXAS[i].minimo) return FAIXAS[i].cards;
    }
    return 0;
  }

  function linhaDoBrinde(carrinho) {
    for (var i = 0; i < carrinho.items.length; i++) {
      if (ehBrinde(carrinho.items[i])) {
        return { chave: carrinho.items[i].key, quantidade: carrinho.items[i].quantity };
      }
    }
    return null;
  }

  /* ------------------------------------------------------------- redesenho --
     Este tema NÃO tem #shopify-section-cart-drawer: o drawer é snippet no
     layout (<cart-drawer class="n10-cart"> / #CartDrawer) e a página do
     carrinho usa as seções cart-items / cart-footer (templates/cart.json).
     Por isso pedimos as seções no próprio POST e reaproveitamos os métodos
     que o tema já tem, em vez de remontar HTML na mão.
     renderSections(), nunca renderContents(): este último ABRE o drawer, e o
     brinde entra sozinho, sem clique do cliente.                            */

  function secoesPedidas() {
    var s = [];
    if (document.querySelector('cart-drawer')) s.push('cart-drawer');
    s.push('cart-icon-bubble');
    return s;
  }

  function redesenhar(dados) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && dados && dados.sections && typeof drawer.renderSections === 'function') {
      drawer.renderSections(dados.sections);
    }
    var pagina = document.querySelector('cart-items');
    if (pagina && typeof pagina.onCartUpdate === 'function') pagina.onCartUpdate();

    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'n10-brinde', cartData: dados });
    }
  }

  /* ------------------------------------------------------------------ núcleo */

  function conferir() {
    if (rodando) {
      repetir = true;
      return Promise.resolve();
    }
    rodando = true;

    return json('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (carrinho) {
        if (!carrinho || !carrinho.items) return null;

        var alvo = cardsDevidos(baseDeCalculo(carrinho));
        var linha = linhaDoBrinde(carrinho);
        var atual = linha ? linha.quantidade : 0;

        if (alvo === atual) return null;

        var corpo;
        var url;

        if (!linha) {
          url = '/cart/add.js';
          corpo = {
            items: [{ id: VARIANT_ID, quantity: alvo, properties: { _brinde: 'true' } }],
            sections: secoesPedidas(),
            sections_url: window.location.pathname,
          };
        } else {
          /* alvo 0 remove a linha */
          url = '/cart/change.js';
          corpo = {
            id: linha.chave,
            quantity: alvo,
            sections: secoesPedidas(),
            sections_url: window.location.pathname,
          };
        }

        return json(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(corpo),
        }).then(function (resposta) {
          /* Sem estoque do card devolve 422. Brinde é "sujeito a
             disponibilidade": registra e segue, nunca trava a compra. */
          if (resposta && resposta.status && resposta.status >= 400) {
            console.warn('[n10-brinde] carrinho recusou o brinde:', resposta.description || resposta.message);
            return null;
          }
          return resposta;
        });
      })
      .then(function (dados) {
        if (dados) return redesenhar(dados);
      })
      .catch(function (e) {
        console.warn('[n10-brinde]', e);
      })
      .then(function () {
        rodando = false;
        if (repetir) {
          repetir = false;
          return conferir();
        }
      });
  }

  /* Espera o carrinho assentar antes de conferir, para não brigar com o tema. */
  var agendado = null;
  function agendar() {
    clearTimeout(agendado);
    agendado = setTimeout(conferir, 250);
  }

  /* --------------------------------------------------------------- gatilhos */

  /* 1. Qualquer POST do tema para /cart/add|change|update|clear.
        Ignora as chamadas do próprio brinde para não entrar em laço. */
  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, opcoes) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var mexeuNoCarrinho = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var meu = false;
    try {
      meu = !!(opcoes && opcoes.body && String(opcoes.body).indexOf('"_brinde"') > -1);
    } catch (e) {}
    return fetchOriginal.apply(this, arguments).then(function (resposta) {
      if (mexeuNoCarrinho && !meu) agendar();
      return resposta;
    });
  };

  /* 2. Eventos do Dawn e do tema Next10. */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'n10-brinde') return;
      agendar();
    });
  }
  document.addEventListener('cart:refresh', agendar);

  /* 3. Carga da página. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else {
    agendar();
  }

  /* 4. Última conferência antes do checkout.
        O desconto de 100% vale sempre que o card está no carrinho, então quem
        adicionar o produto na mão sem atingir a faixa levaria de graça. É aqui
        que essa porta fecha: NÃO remover este bloco numa simplificação. */
  document.addEventListener(
    'click',
    function (evento) {
      var alvo = evento.target.closest
        ? evento.target.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"]')
        : null;
      if (!alvo || alvo.dataset.n10BrindeOk === '1') return;
      evento.preventDefault();
      alvo.dataset.n10BrindeOk = '1';
      conferir().then(function () {
        alvo.click();
      });
    },
    true
  );
})();
